/* eslint-disable no-undef */
//@ts-nocheck
let commonAnalyticsData;
const createBody = (data?) => {
  let productIds = [];
  commonAnalyticsData?.products?.map((product) => {
    productIds = [...productIds, `${product['Product ID']}`];
  });
  return {
    tag: 'GoKwik',
    promo_code: commonAnalyticsData?.coupon || '',
    cart_total_price: commonAnalyticsData?.cart_after_discount,
    product_id: productIds || [],
    first_name: '',
    last_name: '',
    email: '',
    full_address: '',
    city: '',
    state: '',
    address_type: '',
    shipping_method: '',
    abc_url: '',
    pincode: '',
    landing_page: commonAnalyticsData?.marketingData?.['Landing Page'],
    origin_referrer: commonAnalyticsData?.marketingData?.['Origin Referrer'],
    utm_source: commonAnalyticsData?.marketingData?.['Utm Source'],
    utm_medium: commonAnalyticsData?.marketingData?.['Utm Medium'],
    utm_campaign: commonAnalyticsData?.marketingData?.['Utm Campaign'],
    utm_term: commonAnalyticsData?.marketingData?.['Utm Term'],
    utm_content: commonAnalyticsData?.marketingData?.['Utm Content'],
    ...data,
  };
};

export const callContlo = (eventName, data) => {
  data.commonAnalyticsData && (commonAnalyticsData = data.commonAnalyticsData);
  if (eventName === 'mobileAddedGK') {
    contloMobile(data);
  } else if (eventName === 'pinCode') {
    contloPincode(data);
  } else if (eventName === 'paymentMethod') {
    contloPaymentMethod(data);
  } else if (eventName === 'paymentCompleted') {
    contloPaymentCompleted(data);
  } else if (eventName === 'userAddress') {
    contloAddressAdded(data);
  } else if (eventName === 'coupon_applied_success_gk' || eventName === 'coupon_applied_failed_gk') {
    contloDiscountEvent(eventName, data);
  }
};

const contloDiscountEvent = (eventName, data) => {
  let dataObj = {
    eventName: eventName,
    data: createBody({
      first_name: data.userAddress?.firstname,
      last_name: data.userAddress?.lastname,
      email: data.userAddress?.email,
      promo_code: data?.evt?.coupon_code,
      amount_saved: data?.evt?.amount_saved || 0,
      checkout_step: data?.evt?.checkout_step?.split(' ')[0].trim() || '',
      abc_url: data.abcURL,
      landing_page: data.commonAnalyticsData?.marketingData?.['Landing Page'],
      origin_referrer: data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      utm_source: data.commonAnalyticsData?.marketingData?.['Utm Source'],
      utm_medium: data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      utm_campaign: data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      utm_term: data.commonAnalyticsData?.marketingData?.['Utm Term'],
      utm_content: data.commonAnalyticsData?.marketingData?.['Utm Content'],
    }),
  };
  contloSendEvent(eventName, data?.userAddress?.email, data?.phoneNumber, dataObj.data);
};

const contloMobile = (data) => {
  let dataObj = {
    eventName: 'mobile_added_gk',
    data: createBody({
      abc_url: data.abcURL,
    }),
  };
  contloSendEvent(dataObj.eventName, data.userAddress?.email, data?.phoneNumber, dataObj.data);
};

const contloPincode = (data) => {
  let dataObj = {
    eventName: 'pin_code_added_gk',
    data: createBody({
      Pincode: `${data.evt.pincode}`,
    }),
  };
  contloSendEvent(dataObj.eventName, data.userAddress?.email, data.phoneNumber, dataObj.data);
};

const contloPaymentMethod = (data) => {
  let dataObj = {
    eventName: 'payment_method_selected_gk',
    data: createBody({
      first_name: data.userAddress?.firstname,
      last_name: data.userAddress?.lastname,
      email: data.userAddress?.email,
      full_address: data.userAddress?.address,
      city: data.userAddress?.city,
      state: data.userAddress?.state,
      pincode: `${data.userAddress?.pincode}`,
      address_type: data.userAddress?.addresstype,
      shipping_method: data.shippingMethod || 'Standard',
      payment_method: data.evt.paymentMethod,
    }),
  };
  contloSendEvent(dataObj.eventName, data.userAddress?.email, data.phoneNumber, dataObj.data);
};

const contloPaymentCompleted = (data) => {
  let dataObj = {
    eventName: 'payment_complete_gk',
    data: {
      first_name: data.userAddress?.firstname,
      last_name: data.userAddress?.lastname,
      email: data.userAddress?.email,
      full_address: data.userAddress?.address,
      city: data.userAddress?.city,
      state: data.userAddress?.state,
      pincode: `${data.userAddress?.pincode}`,
      address_type: data.userAddress?.addresstype,
      shipping_method: data.shippingMethod || 'Standard',
      payment_method: data?.paymentMethod,
      landing_page: data.commonAnalyticsData?.marketingData?.['Landing Page'],
      origin_referrer: data.commonAnalyticsData?.marketingData?.['Origin Referrer'],
      utm_source: data.commonAnalyticsData?.marketingData?.['Utm Source'],
      utm_medium: data.commonAnalyticsData?.marketingData?.['Utm Medium'],
      utm_campaign: data.commonAnalyticsData?.marketingData?.['Utm Campaign'],
      utm_term: data.commonAnalyticsData?.marketingData?.['Utm Term'],
      utm_content: data.commonAnalyticsData?.marketingData?.['Utm Content'],
    },
  };
  contloSendEvent(dataObj.eventName, data?.userAddress?.email, data.phoneNumber, dataObj.data);
};

const contloAddressAdded = (data) => {
  let dataObj = {
    eventName: 'address_added_gk',
    data: createBody({
      first_name: data.evt?.userAddress?.firstname,
      last_name: data.evt?.userAddress?.lastname,
      email: data.evt?.userAddress?.email,
      full_address: data.evt?.userAddress?.address,
      city: data.evt?.userAddress?.city,
      state: data.evt?.userAddress?.state,
      pincode: `${data.evt?.userAddress?.pincode}`,
      address_type: data.evt?.userAddress?.addresstype,
      shipping_method: data.shippingMethod,
      abc_url: `${data.merchantUrl}?mrid=${data.request_id}`,
    }),
  };
  contloSendEvent(dataObj.eventName, data.evt?.userAddress?.email, data.evt?.userAddress?.phone, dataObj.data);
};

const contloSendEvent = (event, email, phone_number, properties) => {
  window.contlo.sendEvent(event, email, phone_number, properties);
};
